import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmAddressType } from '../interfaces/IKnmAddressType';

export async function fetchKnmAddressTypes(): Promise<IKnmAddressType[]> {
  return apiGet<IKnmAddressType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-address-types`);
}

export async function createKnmAddressType(knmAddressType: Omit<IKnmAddressType, 'id'>): Promise<void> {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-address-types`,
    body: knmAddressType,
  });
}

export async function updateKnmAddressType(knmAddressType: IKnmAddressType): Promise<void> {
  const { id, ...data } = knmAddressType;

  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-address-types/${id}`, data);
}
